module.exports = __webpack_public_path__ + "static/img/pic5.83362bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slideShow/pic5.jpg
// module id = 0xhb
// module chunks = 0